import styled from 'styled-components';

export const FlipContainer = styled.div`
  width: 600px;
  height: 300px;
  background-color: transparent;
  border-radius: 8px;
  perspective: 1000px;
  margin: 8px;
  padding: 8px;
  position: relative;
  z-index: 1;

  &:hover .rotate-flip {
    transform: rotateY(180deg);
  }

  @media (max-width: 768px) {
    width: 350px;
    height: 250px;
  }
`;

export const FlipInnerContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.8s;
`;

export const FlipFront = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 100%;
  background: #222;
  color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 8px;
`;

export const Image = styled.div`
  height: 100%;
  width: 100%;
  background-image: url(${({ background }) => background});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
`;

export const FlipBack = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 8px;
  background: #222;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 8px;
  transform: rotateY(180deg);

  h1 {
    color: #fff;
    font-size: 20px;
    margin-bottom: 8px;
  }

  p {
    color: #fff;
    font-size: 14px;
    margin-bottom: 8px;
    line-height: 20px;
  }

  p + p {
    margin-bottom: 16px;
  }

  a {
    display: block;
    width: 50%;
    padding: 8px;
    background: #333;
    text-decoration: none;
    color: #fff;
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    transition: color 0.2s;
  }

  a:hover {
    color: #007fff;
  }
`;
